import React from 'react';
import {
  Box,
  CardContent,
  Button,
  TableContainer,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Tooltip
} from '@mui/material';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { format } from 'date-fns';
import Client from '../Client';
import BackofficeReportsApi from './backofficeReportsApi';

let d = new Date();
let today = format(d, 'yyyy-MM-dd');

function thousandsSeparator(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

const objectToCsv = function (data) {
  const csvRows = [];
  const headers = Object.keys(data[0]);
  csvRows.push(headers.join(','));

  for (const row of data) {
    const values = headers.map(header => {
      const val = row[header];
      return `"${val}"`;
    });
    csvRows.push(values.join(','));
  }

  return csvRows.join('\n');
};

class SalesTransPeriodLocationList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      client: new Client("none"),
      saleslocation_list: [],
      page: 0,
      platform: 0,
      date: today,
      rowsPerPage: -1,
      sx_hidden: { display: 'none' },
      value: "1",
      filterData: {}
    };

    this.getData = this.getData.bind(this);
    this.doSync = this.doSync.bind(this);
    this.handleChangePage = this.handleChangePage.bind(this);
    this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);
  }

  componentDidMount() {
    if (this.props.date) {
      this.setState({ date: this.props.date }, () => {
        this.getData();
      });
    }

    if (this.props.platform) {
      this.setState({ platform: this.props.platform }, () => {
        this.getData();
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.date !== this.props.date) {
      if (this.props.date) {
        this.setState({ date: this.props.date }, () => {
          this.getData();
        });
      }
    }

    if (prevProps.platform !== this.props.platform) {
      if (this.props.platform >= 0) {
        this.setState({ platform: this.props.platform }, () => {
          this.getData();
        });
      }
    }
  }

  getData() {
    let queryData = {
      date: this.state.date,
      platform: this.state.platform
    };

    let data = BackofficeReportsApi.getSalesLocationTransactionComparison(this.state.client, queryData);

    if (data) {
      this.setState({ saleslocation_list: data });
    }

    this.setState({ filterData: queryData });
  }

  doSync() {
    this.getData();
    this.setState({ page: 0 });
  }

  filterByGroup = (rows) => {
    const { selectedLocationGroup, locations } = this.props;

    if (!selectedLocationGroup || selectedLocationGroup === "all") return rows;
    if (!Array.isArray(locations) || locations.length === 0) return rows;

    const byName = {};
    locations.forEach((loc) => {
      if (loc.name) byName[loc.name.toLowerCase()] = loc;
    });

    return rows.filter((r) => {
      const key = (r.name || "").toLowerCase();
      let loc = byName[key];

      if (!loc) return false;

      const groups = Array.isArray(loc.locationGroup) ? loc.locationGroup : [];
      return groups.includes(selectedLocationGroup);
    });
  };

  computeSubtotals = (rows, mode) => {
    let a = 0, b = 0, c = 0;

    rows.forEach((r) => {
      if (mode === "day") {
        a += parseFloat(r.salesToday || 0);
        b += parseFloat(r.salesToday_LW || 0);
        c += parseFloat(r.salesToday_LY || 0);
      } else if (mode === "week") {
        a += parseFloat(r.salesTW || 0);
        b += parseFloat(r.salesLW || 0);
        c += parseFloat(r.salesTW_LY || 0);
      } else if (mode === "month") {
        a += parseFloat(r.salesTM || 0);
        b += parseFloat(r.salesLM || 0);
        c += parseFloat(r.salesTM_LY || 0);
      } else if (mode === "year") {
        a += parseFloat(r.salesTY || 0);
        b += parseFloat(r.salesLY || 0);
      }
    });

    let pct1 = 0, pct2 = 0;

    if (mode === "day") {
      pct1 = b > 0 ? (a / b) * 100 : 0;
      pct2 = c > 0 ? (a / c) * 100 : 0;
    } else if (mode === "week") {
      pct1 = b > 0 ? (a / b) * 100 : 0;
      pct2 = c > 0 ? (a / c) * 100 : 0;
    } else if (mode === "month") {
      pct1 = b > 0 ? (a / b) * 100 : 0;
      pct2 = c > 0 ? (a / c) * 100 : 0;
    } else if (mode === "year") {
      pct1 = b > 0 ? (a / b) * 100 : 0;
    }

    return { a, b, c, pct1, pct2 };
  };

  addDate = (event) => {
    this.setState({ date: event.target.value });
  };

  handleChange = (event, newValue) => {
    this.setState({ value: newValue });
  };

  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage });
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: +event.target.value });
    this.setState({ page: 0 });
  };

  onDownload = () => {
    const link = document.createElement("a");
    link.download = "transPeriodLocation_" + this.state.date + "_" + this.state.platform + ".csv";
    let csvData = objectToCsv(this.state.saleslocation_list.resultT);
    let csvHeader = "Number of transactions\nDate: " + this.state.date + "\nPlatform: " + this.state.platform;
    let csv = "\uFEFF" + csvHeader + "\n" + csvData;
    link.href = "data:text/csv;charset=utf-8," + encodeURIComponent(csv);
    link.click();
  };

  render() {
    let page = this.state.page;
    let rowsPerPage = this.state.rowsPerPage;
    let dtoday = 0;
    let today_LW = 0;
    let today_TWLY = 0;
    let WTD = 0;
    let WTD_LW = 0;
    let WTD_LY = 0;
    let MTD = 0;
    let MTD_LM = 0;
    let MTD_LY = 0;
    let YTD = 0;
    let YTD_LY = 0;

    let locationSalesList = [];

    if (this.state.saleslocation_list) {
      if (this.state.saleslocation_list.resultT) {
        let counter = 0;

        Object.keys(this.state.saleslocation_list.resultT).forEach(key => {
          let fData = this.state.saleslocation_list.resultT[key];

          let p = {
            id: counter + 1,
            name: fData.name,
            salesToday: fData.sales_Today,
            salesToday_LW: fData.sales_TodayLW,
            salesToday_LY: fData.sales_TodayLY,
            salesTW: fData.sales_TW,
            salesLW: fData.sales_LW,
            salesTW_LY: fData.sales_TWLY,
            salesTM: fData.sales_TM,
            salesLM: fData.sales_LM,
            salesTM_LY: fData.sales_TMLY,
            salesTY: fData.sales_TY,
            salesLY: fData.sales_LY
          };

          counter += 1;
          locationSalesList.push(p);
        });
      }

      if (this.state.saleslocation_list.dates) {
        Object.keys(this.state.saleslocation_list.dates).forEach(key => {
          let dData = this.state.saleslocation_list.dates[key];

          dtoday = dData.today;
          today_LW = dData.today_LW;
          today_TWLY = dData.today_TWLY;
          WTD = dData.WTD;
          WTD_LW = dData.WTD_LW;
          WTD_LY = dData.WTD_LY;
          MTD = dData.MTD;
          MTD_LM = dData.MTD_LM;
          MTD_LY = dData.MTD_LY;
          YTD = dData.YTD;
          YTD_LY = dData.YTD_LY;
        });
      }
    }

    const filteredList = this.filterByGroup(locationSalesList);
    const daySubs = this.computeSubtotals(filteredList, "day");
    const weekSubs = this.computeSubtotals(filteredList, "week");
    const monthSubs = this.computeSubtotals(filteredList, "month");
    const yearSubs = this.computeSubtotals(filteredList, "year");

    const tableContainerSx = {
      height: {
        xs: 480,
        sm: 450,
      },
      overflowX: 'auto',
      borderTop: '1px solid rgba(15, 23, 42, 0.06)',
      '&::-webkit-scrollbar': {
        height: 8,
        width: 8,
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: 'rgba(15, 23, 42, 0.18)',
        borderRadius: 999,
      },
      '&::-webkit-scrollbar-track': {
        backgroundColor: 'rgba(15, 23, 42, 0.04)',
      },
    };

    const isYearTab = this.state.value === "4";

    const tableSx = {
      minWidth: isYearTab
        ? {
            xs: '100%',
            sm: '100%',
            md: 460,
          }
        : {
            xs: 520,
            sm: 600,
            md: 640,
          },
      width: '100%',
      tableLayout: {
        xs: 'fixed',
        md: 'fixed',
      },
      '& .MuiTableCell-root': {
        borderBottom: '1px solid rgba(15, 23, 42, 0.06)',
        fontSize: {
          xs: '0.82rem',
          sm: '0.86rem',
          md: '0.88rem',
        },
      },
      '& .MuiTableRow-hover:hover': {
        backgroundColor: 'rgba(26, 35, 126, 0.035)',
      },
    };

    const headerCellSx = {
      py: {
        xs: 0.6,
        sm: 0.75,
        md: 0.75,
      },
      px: {
        xs: 0.35,
        sm: 0.55,
        md: 0.65,
      },
      bgcolor: '#f8fafc',
      color: '#1a237e',
      fontWeight: 650,
      fontSize: {
        xs: '0.84rem',
        sm: '0.88rem',
        md: '0.9rem',
      },
      lineHeight: 1.15,
      whiteSpace: 'nowrap',
      textTransform: 'uppercase',
      letterSpacing: 0,
    };

    const nameHeaderCellSx = {
      ...headerCellSx,
      position: 'sticky',
      left: 0,
      zIndex: 4,
      width: {
        xs: 112,
        sm: 140,
        md: 155,
      },
      minWidth: {
        xs: 112,
        sm: 140,
        md: 155,
      },
      maxWidth: {
        xs: 112,
        sm: 150,
        md: 170,
      },
    };

    const cellSx = {
      py: {
        xs: 0.6,
        sm: 0.7,
        md: 0.7,
      },
      px: {
        xs: 0.35,
        sm: 0.55,
        md: 0.65,
      },
      textAlign: 'right',
      whiteSpace: 'nowrap',
      color: '#111827',
      fontWeight: 450,
      width: {
        xs: 78,
        sm: 86,
        md: 'auto',
      },
    };

    const nameCellSx = {
      ...cellSx,
      textAlign: 'left',
      position: 'sticky',
      left: 0,
      zIndex: 2,
      bgcolor: '#fff',
      width: {
        xs: 112,
        sm: 140,
        md: 155,
      },
      minWidth: {
        xs: 112,
        sm: 140,
        md: 155,
      },
      maxWidth: {
        xs: 112,
        sm: 150,
        md: 170,
      },
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      fontWeight: 550,
    };

    const subtotalRowSx = {
      '& .MuiTableCell-root': {
        bgcolor: 'rgba(26, 35, 126, 0.055)',
        color: '#111827',
        fontWeight: 900,
        borderTop: '1px solid rgba(26, 35, 126, 0.12)',
      },
      '& .MuiTableCell-root:first-of-type': {
        color: '#1a237e',
      },
    };

    const paginationSx = {
      borderTop: '1px solid rgba(15, 23, 42, 0.06)',
      bgcolor: '#fff',
      minHeight: {
        xs: 44,
        sm: 52,
      },
      '& .MuiTablePagination-toolbar': {
        minHeight: {
          xs: 44,
          sm: 52,
        },
        px: {
          xs: 0.5,
          sm: 1,
        },
        flexWrap: {
          xs: 'wrap',
          sm: 'nowrap',
        },
        gap: {
          xs: 0.25,
          sm: 0.5,
        },
      },
      '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
        fontSize: {
          xs: '0.88rem',
          sm: '0.92rem',
          md: '1rem',
        },
        m: 0,
      },
      '& .MuiTablePagination-actions': {
        ml: {
          xs: 0,
          sm: 1,
        },
      },
    };

    return (
      <CardContent
        sx={{
          p: '0 !important',
          height: '100%',
          width: '100%',
          boxSizing: 'border-box',
          overflow: 'hidden',
          bgcolor: '#fff',
        }}
      >
        <Box
          sx={{
            px: {
              xs: 0.75,
              sm: 1,
            },
            py: {
              xs: 0.65,
              sm: 0.85,
            },
            display: 'flex',
            flexWrap: {
              xs: 'nowrap',
              sm: 'nowrap',
            },
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: {
              xs: 0.75,
              sm: 1,
            },
            borderBottom: '1px solid rgba(15, 23, 42, 0.06)',
            bgcolor: 'linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)',
          }}
        >
          <Box
            sx={{
              minWidth: 0,
              flex: 1,
              overflowX: 'auto',
              '&::-webkit-scrollbar': {
                display: 'none',
              },
              scrollbarWidth: 'none',
            }}
          >
            <Tabs
              value={this.state.value}
              onChange={this.handleChange}
              aria-label="tabs example"
              variant="scrollable"
              scrollButtons="auto"
              allowScrollButtonsMobile
              sx={{
                minHeight: 36,
                '& .MuiTabs-flexContainer': {
                  gap: 0.5,
                },
                '& .MuiTabs-indicator': {
                  display: 'none',
                },
                '& .MuiTab-root': {
                  minHeight: 34,
                  minWidth: {
                    xs: 62,
                    sm: 76,
                  },
                  px: {
                    xs: 1,
                    sm: 1.4,
                  },
                  py: 0,
                  borderRadius: 999,
                  textTransform: 'none',
                  fontWeight: 650,
                  fontSize: {
                    xs: '0.88rem',
                    sm: '0.92rem',
                    md: '1rem',
                  },
                  color: '#64748b',
                  border: '1px solid transparent',
                },
                '& .MuiTab-root.Mui-selected': {
                  color: '#1a237e',
                  bgcolor: 'rgba(26, 35, 126, 0.08)',
                  borderColor: 'rgba(26, 35, 126, 0.14)',
                },
              }}
            >
              <Tab label="Day" value="1" />
              <Tab label="Week" value="2" />
              <Tab label="Month" value="3" />
              <Tab label="Year" value="4" />
            </Tabs>
          </Box>

          <Tooltip title="Download CSV">
            <Button
              color="inherit"
              size="small"
              onClick={this.onDownload}
              variant="contained"
              sx={{
                minWidth: 36,
                width: 36,
                height: 36,
                p: 0,
                flexShrink: 0,
                borderRadius: '12px',
                color: '#1a237e',
                bgcolor: 'rgba(26, 35, 126, 0.08)',
                boxShadow: 'none',
                border: '1px solid rgba(26, 35, 126, 0.12)',
                '&:hover': {
                  bgcolor: 'rgba(26, 35, 126, 0.12)',
                  boxShadow: 'none',
                },
              }}
            >
              <FileDownloadIcon fontSize="small" />
            </Button>
          </Tooltip>
        </Box>

        <Box sx={{ width: '100%', minWidth: 0 }}>
          {this.state.value === "1" ? (
            <Box>
              <TableContainer sx={tableContainerSx}>
                <Table stickyHeader aria-label="sticky table" sx={tableSx}>
                  <TableHead>
                    <TableRow>
                      <TableCell sx={nameHeaderCellSx}>Location</TableCell>
                      <TableCell sx={headerCellSx} align="right">
                        <Tooltip title={dtoday}>
                          <Box component="span">Today</Box>
                        </Tooltip>
                      </TableCell>
                      <TableCell sx={headerCellSx} align="right">
                        <Tooltip title={today_LW}>
                          <Box component="span">T_LW</Box>
                        </Tooltip>
                      </TableCell>
                      <TableCell sx={headerCellSx} align="right">%_LW</TableCell>
                      <TableCell sx={headerCellSx} align="right">
                        <Tooltip title={today_TWLY}>
                          <Box component="span">TW_LY</Box>
                        </Tooltip>
                      </TableCell>
                      <TableCell sx={headerCellSx} align="right">%W_LY</TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {(rowsPerPage > 0 ? filteredList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) : filteredList).map((location) => {
                      return (
                        <TableRow hover key={location.id} tabIndex={-1}>
                          <TableCell sx={nameCellSx}>{location.name}</TableCell>
                          <TableCell sx={cellSx}>{thousandsSeparator(parseInt(location.salesToday))}</TableCell>
                          <TableCell sx={cellSx}>{thousandsSeparator(parseInt(location.salesToday_LW))}</TableCell>
                          <TableCell sx={cellSx}>
                            {location.salesToday_LW === 0 ? 0 + "%" : parseInt((location.salesToday / location.salesToday_LW) * 100) + "%"}
                          </TableCell>
                          <TableCell sx={cellSx}>{thousandsSeparator(parseInt(location.salesToday_LY))}</TableCell>
                          <TableCell sx={cellSx}>
                            {location.salesToday_LY === 0 ? 0 + "%" : parseInt((location.salesToday / location.salesToday_LY) * 100) + "%"}
                          </TableCell>
                        </TableRow>
                      );
                    })}

                    {this.props.selectedLocationGroup !== "all" && (
                      <TableRow sx={subtotalRowSx}>
                        <TableCell sx={nameCellSx}>Subtotal</TableCell>
                        <TableCell sx={cellSx}>{thousandsSeparator(parseInt(daySubs.a))}</TableCell>
                        <TableCell sx={cellSx}>{thousandsSeparator(parseInt(daySubs.b))}</TableCell>
                        <TableCell sx={cellSx}>{daySubs.pct1.toFixed(1)}%</TableCell>
                        <TableCell sx={cellSx}>{thousandsSeparator(parseInt(daySubs.c))}</TableCell>
                        <TableCell sx={cellSx}>{daySubs.pct2.toFixed(1)}%</TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>

              <TablePagination
                rowsPerPageOptions={[12, { value: -1, label: 'All' }]}
                labelRowsPerPage="Rows:"
                component="div"
                count={filteredList.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={this.handleChangePage}
                onRowsPerPageChange={this.handleChangeRowsPerPage}
                sx={paginationSx}
              />
            </Box>
          ) : ""}

          {this.state.value === "2" ? (
            <Box>
              <TableContainer sx={tableContainerSx}>
                <Table stickyHeader aria-label="sticky table" sx={tableSx}>
                  <TableHead>
                    <TableRow>
                      <TableCell sx={nameHeaderCellSx}>Location</TableCell>
                      <TableCell sx={headerCellSx} align="right">
                        <Tooltip title={WTD}>
                          <Box component="span">WTD</Box>
                        </Tooltip>
                      </TableCell>
                      <TableCell sx={headerCellSx} align="right">
                        <Tooltip title={WTD_LW}>
                          <Box component="span">WTD_LW</Box>
                        </Tooltip>
                      </TableCell>
                      <TableCell sx={headerCellSx} align="right">%_LW</TableCell>
                      <TableCell sx={headerCellSx} align="right">
                        <Tooltip title={WTD_LY}>
                          <Box component="span">WTD_LY</Box>
                        </Tooltip>
                      </TableCell>
                      <TableCell sx={headerCellSx} align="right">%_LY</TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {(rowsPerPage > 0 ? filteredList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) : filteredList).map((location) => {
                      return (
                        <TableRow hover key={location.id} tabIndex={-1}>
                          <TableCell sx={nameCellSx}>{location.name}</TableCell>
                          <TableCell sx={cellSx}>{thousandsSeparator(parseInt(location.salesTW))}</TableCell>
                          <TableCell sx={cellSx}>{thousandsSeparator(parseInt(location.salesLW))}</TableCell>
                          <TableCell sx={cellSx}>
                            {location.salesLW === 0 ? 0 + "%" : parseInt((location.salesTW / location.salesLW) * 100) + "%"}
                          </TableCell>
                          <TableCell sx={cellSx}>{thousandsSeparator(parseInt(location.salesTW_LY))}</TableCell>
                          <TableCell sx={cellSx}>
                            {location.salesTW_LY === 0 ? 0 + "%" : parseInt((location.salesTW / location.salesTW_LY) * 100) + "%"}
                          </TableCell>
                        </TableRow>
                      );
                    })}

                    {this.props.selectedLocationGroup !== "all" && (
                      <TableRow sx={subtotalRowSx}>
                        <TableCell sx={nameCellSx}>Subtotal</TableCell>
                        <TableCell sx={cellSx}>{thousandsSeparator(parseInt(weekSubs.a))}</TableCell>
                        <TableCell sx={cellSx}>{thousandsSeparator(parseInt(weekSubs.b))}</TableCell>
                        <TableCell sx={cellSx}>{weekSubs.pct1.toFixed(1)}%</TableCell>
                        <TableCell sx={cellSx}>{thousandsSeparator(parseInt(weekSubs.c))}</TableCell>
                        <TableCell sx={cellSx}>{weekSubs.pct2.toFixed(1)}%</TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>

              <TablePagination
                rowsPerPageOptions={[12, { value: -1, label: 'All' }]}
                labelRowsPerPage="Rows:"
                component="div"
                count={filteredList.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={this.handleChangePage}
                onRowsPerPageChange={this.handleChangeRowsPerPage}
                sx={paginationSx}
              />
            </Box>
          ) : ""}

          {this.state.value === "3" ? (
            <Box>
              <TableContainer sx={tableContainerSx}>
                <Table stickyHeader aria-label="sticky table" sx={tableSx}>
                  <TableHead>
                    <TableRow>
                      <TableCell sx={nameHeaderCellSx}>Location</TableCell>
                      <TableCell sx={headerCellSx} align="right">
                        <Tooltip title={MTD}>
                          <Box component="span">MTD</Box>
                        </Tooltip>
                      </TableCell>
                      <TableCell sx={headerCellSx} align="right">
                        <Tooltip title={MTD_LM}>
                          <Box component="span">MTD_LM</Box>
                        </Tooltip>
                      </TableCell>
                      <TableCell sx={headerCellSx} align="right">%_LM</TableCell>
                      <TableCell sx={headerCellSx} align="right">
                        <Tooltip title={MTD_LY}>
                          <Box component="span">MTD_LY</Box>
                        </Tooltip>
                      </TableCell>
                      <TableCell sx={headerCellSx} align="right">%_LY</TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {(rowsPerPage > 0 ? filteredList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) : filteredList).map((location) => {
                      return (
                        <TableRow hover key={location.id} tabIndex={-1}>
                          <TableCell sx={nameCellSx}>{location.name}</TableCell>
                          <TableCell sx={cellSx}>{thousandsSeparator(parseInt(location.salesTM))}</TableCell>
                          <TableCell sx={cellSx}>{thousandsSeparator(parseInt(location.salesLM))}</TableCell>
                          <TableCell sx={cellSx}>
                            {location.salesLM === 0 ? 0 + "%" : parseInt((location.salesTM / location.salesLM) * 100) + "%"}
                          </TableCell>
                          <TableCell sx={cellSx}>{thousandsSeparator(parseInt(location.salesTM_LY))}</TableCell>
                          <TableCell sx={cellSx}>
                            {location.salesTM_LY === 0 ? 0 + "%" : parseInt((location.salesTM / location.salesTM_LY) * 100) + "%"}
                          </TableCell>
                        </TableRow>
                      );
                    })}

                    {this.props.selectedLocationGroup !== "all" && (
                      <TableRow sx={subtotalRowSx}>
                        <TableCell sx={nameCellSx}>Subtotal</TableCell>
                        <TableCell sx={cellSx}>{thousandsSeparator(parseInt(monthSubs.a))}</TableCell>
                        <TableCell sx={cellSx}>{thousandsSeparator(parseInt(monthSubs.b))}</TableCell>
                        <TableCell sx={cellSx}>{monthSubs.pct1.toFixed(1)}%</TableCell>
                        <TableCell sx={cellSx}>{thousandsSeparator(parseInt(monthSubs.c))}</TableCell>
                        <TableCell sx={cellSx}>{monthSubs.pct2.toFixed(1)}%</TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>

              <TablePagination
                rowsPerPageOptions={[12, { value: -1, label: 'All' }]}
                labelRowsPerPage="Rows:"
                component="div"
                count={filteredList.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={this.handleChangePage}
                onRowsPerPageChange={this.handleChangeRowsPerPage}
                sx={paginationSx}
              />
            </Box>
          ) : ""}

          {this.state.value === "4" ? (
            <Box>
              <TableContainer sx={tableContainerSx}>
                <Table stickyHeader aria-label="sticky table" sx={tableSx}>
                  <TableHead>
                    <TableRow>
                      <TableCell sx={nameHeaderCellSx}>Location</TableCell>
                      <TableCell sx={headerCellSx} align="right">
                        <Tooltip title={YTD}>
                          <Box component="span">YTD</Box>
                        </Tooltip>
                      </TableCell>
                      <TableCell sx={headerCellSx} align="right">
                        <Tooltip title={YTD_LY}>
                          <Box component="span">YTD_LY</Box>
                        </Tooltip>
                      </TableCell>
                      <TableCell sx={headerCellSx} align="right">%_LY</TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {(rowsPerPage > 0 ? filteredList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) : filteredList).map((location) => {
                      return (
                        <TableRow hover key={location.id} tabIndex={-1}>
                          <TableCell sx={nameCellSx}>{location.name}</TableCell>
                          <TableCell sx={cellSx}>{thousandsSeparator(parseInt(location.salesTY))}</TableCell>
                          <TableCell sx={cellSx}>{thousandsSeparator(parseInt(location.salesLY))}</TableCell>
                          <TableCell sx={cellSx}>
                            {location.salesLY === 0 ? 0 + "%" : parseInt((location.salesTY / location.salesLY) * 100) + "%"}
                          </TableCell>
                        </TableRow>
                      );
                    })}

                    {this.props.selectedLocationGroup !== "all" && (
                      <TableRow sx={subtotalRowSx}>
                        <TableCell sx={nameCellSx}>Subtotal</TableCell>
                        <TableCell sx={cellSx}>{thousandsSeparator(parseInt(yearSubs.a))}</TableCell>
                        <TableCell sx={cellSx}>{thousandsSeparator(parseInt(yearSubs.b))}</TableCell>
                        <TableCell sx={cellSx}>{yearSubs.pct1.toFixed(1)}%</TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>

              <TablePagination
                rowsPerPageOptions={[12, { value: -1, label: 'All' }]}
                labelRowsPerPage="Rows:"
                component="div"
                count={filteredList.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={this.handleChangePage}
                onRowsPerPageChange={this.handleChangeRowsPerPage}
                sx={paginationSx}
              />
            </Box>
          ) : ""}
        </Box>
      </CardContent>
    );
  }
}

export default SalesTransPeriodLocationList;
